import { Col, Row } from 'antd';
import { MultiStepFormProvider } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import useSession from 'hooks/useSession';
import { StyledPageWrapper } from 'components/new-ui/base/wrappers/styles';
import FormContent from 'components/new-ui/composed/multistep-form/FormContent';
import { StepsSidebar } from 'components/new-ui/composed/multistep-form/StepsSidebar';
import CreateManifestPageHeader from './components/CreateManifestPageHeader';
import { initialManifestValues, ManifestFormFields } from './types';
import { getStepsConfig } from './stepsConfig';
import { useSearchParams } from 'react-router-dom';

const CreateManifestForm = () => {
    const { isFreightForwarderAdminUser, isSuperAdminUser } = useSession();
    const [searchParams] = useSearchParams();

    const teamId = searchParams.get('teamId');
    const isAdmin = isFreightForwarderAdminUser || isSuperAdminUser;
    const isUnderTeam = Boolean(teamId);

    const stepsConfig = getStepsConfig(isAdmin, isUnderTeam);

    return (
        <MultiStepFormProvider<ManifestFormFields>
            initialValues={initialManifestValues}
            steps={stepsConfig}
            autocompleteDelayMs={1200}
        >
            <StyledPageWrapper>
                <CreateManifestPageHeader />
                <Row style={{ marginTop: 32 }} gutter={20}>
                    <Col style={{ maxWidth: 210 }} sm={24} md={6}>
                        <StepsSidebar />
                    </Col>
                    <Col sm={24} md={18}>
                        <FormContent />
                    </Col>
                </Row>
            </StyledPageWrapper>
        </MultiStepFormProvider>
    );
};

export default CreateManifestForm;
